import { RecordOf } from '@opengov/compose-app/immutable';

import { IErrorMessage } from './types';

export const ErrorMessage = RecordOf<IErrorMessage<any> & { id: number }>({
  code: null,
  severity: null,
  id: null,
  payload: null
});
